

























































// @ is an alias to /src
import { AloPlat } from '@/models/alo/AloPlat'
import { Component, Vue, Watch } from 'vue-property-decorator'
import {ItemPanier} from '@/models/alo/ItemPanier'
import { VuetifyConfirmObject } from 'node_modules/vuetify-confirm/types'
import { AloBaseLg, getDefaultAloBaseLg } from '@/models/alo/AloBaseLg'
import { mixins } from 'vue-class-component'
import BasePlat from '@/components/carte/BasePlat'
import PlatEditable from './PlatEditable'


@Component({
  name: 'ProduitAccompagnement'
})
export default class ProduitAccompagnement extends mixins(BasePlat,PlatEditable) {  
  itemPanier:ItemPanier = new ItemPanier()
  showCuisson = false
  showParfum = false
  autoAdd = false

  get platSelected(){
    return this.plat.selected
  }
  
  @Watch("platSelected")
  onPlatSelectedChange(){
    //Commenté car Florent est en négo avec le client
    this.showCuisson = /*!!this.directValidation &&*/ !!this.plat.selected && !!this.mustSelectCuisson && this.itemPanier.cuisson?.lgs.length == 0
    //@ts-ignore
    this.showParfum = !!this.plat.selected && this.mustSelectParfum && this.itemPanier.parfum?.lgs.length == 0
    this.autoAdd = this.directValidation
  }

  get platsDic(){
    return this.$store.myGetters.platsDic

  }

  get mustSelectParfum(){    
    //@ts-ignore
    return (this.$gt(this.plat).parfums || []).length > 0
  }

  get mustSelectCuisson(){ 
    //@ts-ignore
    return (this.$gt(this.plat).cuissons || []).length > 0 
  }

  get directValidation(){
    return ((this.mustSelectCuisson && !this.mustSelectParfum) || (!this.mustSelectCuisson && this.mustSelectParfum ) )
        && this.plat.accompagnementsIds?.length == 0 && !this.isEdited
  }

  get isSimpleProduct() {
    return (!this.mustSelectCuisson && !this.mustSelectParfum ) && this.plat.accompagnementsIds?.length == 0  
  }
  
  get accompagnementsDic(){
    return this.$store.myGetters.accompagnementsDic
  }

  get accompagnements(){
    return this.plat.accompagnementsIds?.map(id => this.accompagnementsDic[id]) || []
  }

  selectProduct() {  
    if(!this.canAdd) this.$confirm(this.$t('Cart.AlertProductMix').toString(),{title: this.$t('Cart.AlertProductMixTitle'),buttonTrueText:this.$t('Global.Ok'),buttonFalseText:""} as VuetifyConfirmObject)
    else {
      this.itemPanier = new ItemPanier({plat:this.plat,accompagnements:this.accompagnements.map(item => {return {qty:0,item}}),cuisson:{lgs:[]},parfum:{lgs:[]},qty:1,parentId:this.platParentId,sectionId:this.platSectionId,arboId:this.platArboId})    
      if(this.isSimpleProduct){
        this.addItemToPanier()
      }
      else{
        this.$store.myActions.ROOM_SERVICES_PLAT_SET_SELECTION({selected:true,ids:[this.plat.id]})   
      }    
    }
  }

  cancel(){
    if(this.isEdited){
      this.$emit("cancel")
    }
    else {  
      this.$store.myActions.ROOM_SERVICES_PLAT_SET_SELECTION({selected:false,ids:[this.plat.id]})
    }
  }

  addItemToPanier() {
    if(!this.canAdd) this.$confirm(this.$t('Cart.AlertProductMix').toString(),{title: this.$t('Cart.AlertProductMixTitle'),buttonTrueText:this.$t('Global.Ok'),buttonFalseText:""} as VuetifyConfirmObject)
    else 
    { 
      this.autoAdd = false
      if(this.mustSelectCuisson && this.itemPanier.cuisson?.lgs.length == 0) {
        //on le marque en auto add pour qu'a la selection de la cuisson on ajoute l'item au panier
        this.autoAdd = true
        this.showCuisson = true      
      }    
      //@ts-ignore
      else if(this.mustSelectParfum && this.itemPanier.parfum?.lgs.length == 0) {
        //on le marque en auto add pour qu'a la selection de la cuisson on ajoute l'item au panier
        this.autoAdd = true
        this.showParfum = true      
      }    
      else if(this.itemPanier.nbAccompagnements < (this.plat.qtyAccompagnementGratuit || 0)) { 
        this.$confirm(this.$tc('Dish.AlertSideDishes',this.plat.qtyAccompagnementGratuit||0),{title: this.$t('Dish.AlertSideDishesTitle'),buttonTrueText:this.$t('Global.Ok'),buttonFalseText:""} as VuetifyConfirmObject)
      }
      else {
        //this.$store.myActions.ROOM_SERVICES_ADD_PANIER(this.itemPanier)
        this.addToCart(this.itemPanier)
        this.cancel()      
      }
    }
  }

  onCuissonSelected(cuisson:{lgs:Array<AloBaseLg>}) {    
   this.itemPanier.cuisson = cuisson
   if(this.autoAdd) this.addItemToPanier()
  }

  onParfumSelected(parfum:{lgs:Array<AloBaseLg>}){
    this.itemPanier.parfum = parfum    
    if(this.autoAdd) this.addItemToPanier()
  }

  onCancelSelect(){    
    if(this.directValidation) this.cancel()
  }
}
